import { useRef } from 'react';
import type { EtcTicketSummary } from '#/components/ui/tickets/etc/model';

export type ConfirmPaymentOnBehalfResult = { file: File | null };

export type ConfirmPaymentOnBehalfDialogRef = {
  confirm: (
    ticket: EtcTicketSummary,
  ) => Promise<ConfirmPaymentOnBehalfResult | null>;
};

export const useConfirmPaymentOnBehalfDialog = () => {
  const modalRef = useRef<ConfirmPaymentOnBehalfDialogRef>(null);
  const confirm = (ticket: EtcTicketSummary) =>
    modalRef.current?.confirm(ticket);
  return { props: { modalRef }, confirm };
};
